// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-rootwidget .timeline-container-2[data-v-8f9667f2] {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
